import SortDirection from '../enums/sortDirection';
import get from 'lodash.get';
import classnames from 'classnames';
export const getPagedRequest = (sort, pagination, searchValue) => ({
    pagingModel: {
        pageNumber: pagination.pageNumber,
        pageSize: pagination.pageSize,
        sortByItems: [{ columnName: sort.key, order: sort.direction }],
        searchValue: searchValue
    }
});
export const getFormattedColumns = (columns, getTitle) => columns.map((column) => {
    const { children, key, dataIndex, width, render, className, align, ellipsis } = column;
    return {
        title: getTitle(column),
        children: children ? getFormattedColumns(children, getTitle) : null,
        key,
        dataIndex,
        width,
        ellipsis,
        render,
        className: classnames(className, { [`${align}-column`]: align })
    };
});
export const filterBySearchValue = (searchValue, searchableColumns) => (item) => {
    if (!searchValue)
        return true;
    return searchableColumns.some((key) => item[key].toLowerCase().includes(searchValue.toLowerCase()));
};
export const stringColumnSorter = (columnKey, sortDirection) => (firstItem, secondItem) => sortDirection == SortDirection.Ascending ?
    get(firstItem, columnKey).localeCompare(get(secondItem, columnKey)) :
    get(secondItem, columnKey).localeCompare(get(firstItem, columnKey));
export const numberColumnSorter = (columnKey, sortDirection) => (firstItem, secondItem) => sortDirection == SortDirection.Ascending ?
    get(firstItem, columnKey) - get(secondItem, columnKey) :
    get(secondItem, columnKey) - get(firstItem, columnKey);
